import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IUser } from '../../models/user'
import { logout } from '../actions/constants'

export interface IUserState {
  email?: string
  user: IUser | null
  showFirstUse: boolean
  checkEmailStatus?:
    | 'activated'
    | 'multi_relations'
    | 'not_activated'
    | 'not_activated_old'
    | 'not_found',
  pushnotificationsEnabled: boolean
}

const initialState: IUserState = {
  email: undefined,
  user: null,
  showFirstUse: true,
  checkEmailStatus: undefined,
  pushnotificationsEnabled: false
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload
    },
    setShowFirstUse: (state, action: PayloadAction<boolean>) => {
      state.showFirstUse = action.payload
    },
    setEmail: (state, action: PayloadAction<string | undefined>) => {
      state.email = action.payload
    },
    setCheckEmailStatus: (
      state,
      action: PayloadAction<IUserState['checkEmailStatus']>
    ) => {
      state.checkEmailStatus = action.payload
    },
    setPushnotificationsEnabled: (state, action: PayloadAction<boolean>) => {
      state.pushnotificationsEnabled = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => ({
      ...initialState,
      email: state.email,
      showFirstUse: state.showFirstUse,
      pushnotificationsEnabled: state.pushnotificationsEnabled
    }))
  }
})

export const { setUser, setShowFirstUse, setCheckEmailStatus, setEmail, setPushnotificationsEnabled } =
  userSlice.actions

export default userSlice.reducer
